export default __webpack_public_path__ + "static/security_w.f4fbdb358986b1d7d17c17a3f36e1523.png";